import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-handicraft-category-list',
  templateUrl: './handicraft-category-list.component.html',
  styleUrls: ['./handicraft-category-list.component.sass']
})
export class HandicraftCategoryListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
